import { createElement } from '@core/helpers';
import Tooltip from 'src/app/project/features/tooltip/Tooltip';
import { GET_CUSTOM_FIELDS } from 'src/app/project/modules/custom-fields/custom-fields.store';
import { EIconPath } from 'src/app/project/shared/enums/icons.enum';
import { TColumn } from '../../../columns/column.model';

export function createDescriptionTooltipElement(column: TColumn): HTMLElement | string {
  if (!column.customFieldIds?.length) {
    return '';
  }

  const customFieldId = column.customFieldIds[0];
  const customFields = GET_CUSTOM_FIELDS();
  const description = customFields[customFieldId]?.description;

  if (!description) {
    return '';
  }

  const tooltipText = description;

  const element = createElement('img', {
    attrs: {
      src: EIconPath.MISC_INFO,
      class: 'table__head__cell--info-icon',
    },
  });

  addTooltip(tooltipText, element);

  return element;
}

function addTooltip(tooltipText: string, element: HTMLElement): void {
  const tooltip = new Tooltip({
    options: {
      placement: 'bottom',
    },
    title: tooltipText,
    mobileTooltip: false,
    trimTooltip: false,
    childTooltip: false,
    element: element,
  });

  tooltip.createTooltip();
}
